import { ColumnInterface } from "components/tables/interfaces";
import Table from "components/tables/table";
import { timestamp } from "lib/date";
import { ListSnapshot } from "models/list-snapshot";
import { FunctionComponent } from "react";

interface LogTableProps {
  listUuid: string;
  listSnapshots: ListSnapshot[];
}

const LogTable: FunctionComponent<LogTableProps> = ({
  listUuid,
  listSnapshots,
}) => {
  const columns: ColumnInterface[] = [
    {
      key: "timestamp",
      header: "Aika",
      width: 200,
      render: (snapshot: ListSnapshot) => {
        return timestamp(snapshot.created_at);
      },
    },
    {
      key: "author",
      header: "Muokkaaja",
      width: 200,
      render: (snapshot: ListSnapshot) => {
        const { author } = snapshot;
        return [author.firstname, author.lastname].join(" ");
      },
    },
  ];

  return (
    <Table
      name={`list-${listUuid}-log`}
      columns={columns}
      data={listSnapshots}
    />
  );
};

export default LogTable;
